<template>
  <div>
    <modal
      :name="modalName"
      :width="1000"
      :height="'auto'"
      :adaptive="true"
      :max-width="1200"
      :class="['u-text-align-center', modalClass]"
      :resizable="true"
      :before-close="beforeClose"
      @closed="hide">
      <div
        style="overflow: scroll; height: 65vh;"
        class="modal-container">
        <div class="dialog-header">
          {{ title }}
          <span
            style="float: right; width: 27px; height: 27px; margin-right: -27px; cursor: pointer;"
            class="close-button"
            @click="hide()">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.0303 8.96965C9.73741 8.67676 9.26253 8.67676 8.96964
       8.96965C8.67675 9.26255 8.67675 9.73742 8.96964 10.0303L10.9393
        12L8.96966 13.9697C8.67677 14.2625 8.67677 14.7374 8.96966
         15.0303C9.26255 15.3232 9.73743 15.3232 10.0303 15.0303L12
          13.0607L13.9696 15.0303C14.2625 15.3232 14.7374 15.3232
           15.0303 15.0303C15.3232 14.7374 15.3232 14.2625 15.0303
            13.9696L13.0606 12L15.0303 10.0303C15.3232 9.73744 15.3232
             9.26257 15.0303 8.96968C14.7374 8.67678 14.2625 8.67678
              13.9696 8.96968L12 10.9393L10.0303 8.96965Z"
                fill="#ccc" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371
         6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75
          12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75
           6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25
            6.89137 21.25 12C21.25 17.1086 17.1086 21.25
             12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z"
                fill="#ccc" />
            </svg>
          </span>
        </div>
        <div class="dialog-body">
          <div class="search-box">
            <div class="search-input-wrapper">
              <svg
                class="search-icon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172
                    3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                  stroke="#999"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M21 21L16.65 16.65"
                  stroke="#999"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <input
                v-model="searchKeyword"
                type="text"
                class="search-input"
                placeholder="アーティスト名で検索"
                @input="debounceSearch">
            </div>
          </div>
          <div class="artist-list">
            <a
              v-for="item in pagination.data"
              :key="item.id"
              class="artist-list__item"
              :class="{
                'artist-list__item--selected': isSelected(item.id),
                'artist-list__item--disabled': isExcluded(item.id),
              }"
              href="#"
              @click.prevent="selectArtist(item)">
              <div
                class="artist-list__pic"
                :style="
                  `background-image: url(/images/${item.image_path || 'artist-no-image-c.jpg'})`
                ">
              </div>
              <div class="artist-list__name">
                <span class="artist-list__name_text">
                  {{ item.name_ja || item.name }}
                  <span
                    v-if="isExcluded(item.id)"
                    class="excluded-badge">選択済み</span>
                </span>
                <span
                  class="c-btn__icon-check"
                  :class="{ 'c-btn__icon-check--on': isSelected(item.id) }">
                </span>
              </div>
              <div
                v-if="isSelected(item.id)"
                class="artist-list__num">
                {{ selectedArtists.indexOf(item.id) + 1 }}
              </div>
            </a>
          </div>
          <div class="pager">
            <div
              v-if="pagination.data"
              class="pager">
              <pagination
                :pagination="pagination"
                @on-pagination-clicked="onPaginationClicked">
              </pagination>
            </div>
          </div>
        </div>
        <div class="dialog-footer c-btn-wrap">
          <a
            class="c-btn"
            href="#"
            @click="hide()">
            キャンセル
            <span class="c-btn__icon-arrow"></span>
          </a>
          <a
            class="c-btn"
            href="#"
            @click.prevent="confirmSelection">
            登録する
            <span class="c-btn__icon-arrow"></span>
          </a>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Pagination from '../../../../components/Pagination'

export default {
  name: 'SelectArtist',
  components: { Pagination },
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    excludedIds: {
      type: Array,
      default: () => [],
    },
    modalName: {
      type: String,
      required: true,
    },
    modalClass: {
      type: String,
      default: 'select-artist-modal',
    },
    title: {
      type: String,
      required: true,
    },
    artistType: {
      type: Number,
      default: 1,
    },
    kanaOptional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pagination: {},
      selectedArtists: [],
      searchKeyword: '',
    }
  },
  watch: {
    isShown() {
      if (this.isShown) {
        this.selectedArtists = [...this.selectedIds]
        this.fetchItems(0)
        this.show()
      } else {
        this.hide()
      }
    },
  },
  created() {
    this.debounceSearch = window._ && window._.debounce ? window._.debounce(() => {
      this.fetchItems(0)
    }, 500) : () => {
      this.fetchItems(0)
    }
  },
  methods: {
    show() {
      this.$modal.show(this.modalName)
    },
    hide() {
      this.$modal.hide(this.modalName)
      this.$emit('close')
    },
    beforeClose() {
      // モーダルを閉じる前の処理
      return true
    },
    isSelected(artistId) {
      return this.selectedArtists.includes(artistId)
    },
    isExcluded(artistId) {
      return this.excludedIds.includes(artistId)
    },
    async fetchItems(page) {
      const params = {
        page,
        count: 16,
        type: this.artistType,
        keyword: this.searchKeyword,
        optional_kana: this.kanaOptional ? 1 : 0,
      }

      const response = await window.axios.get('/api/client/artists', { params })
      this.pagination = response.data
    },
    selectArtist(artist) {
      // 除外対象のアーティストは選択できない
      if (this.isExcluded(artist.id)) {
        return
      }

      const index = this.selectedArtists.indexOf(artist.id)
      if (index === -1) {
        // 新規選択のみ許可（選択解除は無効）
        this.selectedArtists.push(artist.id)
      }
      // 既に選択されている場合は何もしない（選択解除を防ぐ）
    },
    confirmSelection() {
      // 選択中のアーティストの詳細情報を取得
      this.fetchSelectedArtists()
    },
    async fetchSelectedArtists() {
      if (this.selectedArtists.length === 0) {
        this.$emit('select', [])
        this.hide()
        return
      }

      const response = await window.axios.get('/api/client/artists', {
        params: {
          ids: this.selectedArtists.join(','),
          isPaginate: 'false',
          optional_kana: this.kanaOptional ? 1 : 0,
        },
      })

      const artists = response.data

      // カナが未入力の場合は新規アーティスト扱いにしてサーバ保存時に上書きする
      if (artists.some(artist => !artist.name_kana)) {
        artists.forEach(artist => {
          if (!artist.name_kana) {
            // eslint-disable-next-line no-param-reassign
            artist.id = null
            // eslint-enable-next-line no-param-reassign
          }
        })
      }
      this.$emit('select', response.data)
      this.hide()
    },
    onPaginationClicked(page) {
      this.fetchItems(page)
    },
  },
}
</script>

<style scoped>
a.disabled {
  pointer-events: none;
}
.artist-list__item.overlay:before {
  background: rgba(0,0,0,0.6);
  position: absolute;
  z-index: 99;
  content: "";
  width: 100%;
  height: 100%;
}
.overlay-text {
  color: #fff;
  position: absolute;
  z-index: 9999;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  width: 108px;
}
.dialog-header {
  text-align: center;
  font-weight: bold;
  margin-top: 10px;
  padding: 0 40px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  position: relative;
}

@media screen and (min-width: 600px) {
  .dialog-header {
    margin-top: 12px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
  }
}

@media screen and (min-width: 896px) {
  .dialog-header {
    font-size: 20px;
  }
}

.dialog-close-btn {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  font-size: 20px;
  text-decoration: none;
}

.icon-cancel {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url(/images/icon-cancel.png);
  background-size: contain;
  background-repeat: no-repeat;
}

.dialog-body {
  text-align: center;
  vertical-align: middle;
  margin-top: 15px;
  padding: 0 10px;
  overflow-y: auto;
  flex: 1;
}

@media screen and (min-width: 600px) {
  .dialog-body {
    margin-top: 20px;
    padding: 0 20px;
  }
}

.dialog-footer {
  text-align: center;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 10px;
}

@media screen and (min-width: 600px) {
  .dialog-footer {
    flex-direction: row;
    justify-content: center;
    gap: 15px;
  }
}

.search-box {
  margin-bottom: 20px;
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 10px;
}

@media screen and (min-width: 600px) {
  .search-box {
    padding: 0;
  }
}

.search-input-wrapper {
  position: relative;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 1;
}

.search-input {
  width: 100%;
  padding: 10px 12px 10px 40px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.search-input:focus {
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1);
}

.search-input::placeholder {
  color: #999;
}

.artist-list {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}

/* スマホ表示 */
.artist-list__item {
  width: 48%;
  margin-bottom: 15px;
  position: relative;
}

/* タブレット表示 */
@media screen and (min-width: 600px) and (max-width: 895px) {
  .artist-list__item {
    width: 31%;
    margin-bottom: 20px;
  }
}

/* PC表示 */
@media screen and (min-width: 896px) {
  .artist-list__item {
    width: 23%;
    margin-bottom: 20px;
  }
}

.artist-list__name {
  background-color: #f3f3f1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  line-height: 1.3;
  padding: 8px 5px;
  min-height: 40px;
  font-size: 12px;
}

@media screen and (min-width: 600px) {
  .artist-list__name {
    font-size: 14px;
    padding: 8px 10px;
  }
}

@media screen and (min-width: 896px) {
  .artist-list__name {
    font-size: 16px;
    height: 50px;
    padding: 0 40px 0 20px;
  }
}

.artist-list__num {
  border-radius: 50%;
  background-color: #1976d2;
  border: 2px solid #fff;
  position: absolute;
  color: #fff;
  text-align: center;
  font-size: 12px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 5px;
  top: 5px;
  width: 22px;
  height: 22px;
}

@media screen and (min-width: 600px) {
  .artist-list__num {
    font-size: 14px;
    width: 24px;
    height: 24px;
  }
}

@media screen and (min-width: 896px) {
  .artist-list__num {
    font-size: 16px;
    width: 26px;
    height: 26px;
  }
}

.artist-list__pic {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 100%;
  width: 100%;
  transition: 0.3s;
  height: 0;
}

@media screen and (min-width: 896px) {
  .artist-list__pic {
    padding-top: 66.6666%;
  }
}

.c-btn__icon-check {
  width: 20px;
  height: 20px;
  background-image: url(/images/icon-check_off.png);
  background-size: contain;
  margin-left: 5px;
}

.c-btn__icon-check--on {
  background-image: url(/images/icon-check_on.png);
}

.modal-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.select-artist-modal .dialog-body {
  flex: 1;
  overflow-y: auto;
}

.artist-list {
  margin-top: 2rem;
}

/* 選択済みアーティストのスタイル */
.artist-list__item--selected {
  cursor: default;
  opacity: 0.9;
}

.artist-list__item--selected .artist-list__pic {
  filter: brightness(0.95);
}

/* 除外されたアーティストのスタイル */
.artist-list__item--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.artist-list__item--disabled .artist-list__pic {
  filter: grayscale(100%);
}

.excluded-badge {
  display: inline-block;
  background-color: #ff9800;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 3px;
  margin-left: 4px;
  vertical-align: middle;
}
</style>
